import styles from './DiscountSignal.module.scss';
import { useLiveEventData } from '../hooks/useLiveEventData';
import { DiscountSignalIcon } from './DiscountSignalIcon';
import { useIntl } from 'react-intl';

export const DiscountSignal = () => {
  let discountText: string | undefined;
  const { formatMessage } = useIntl();
  const { ticketInfo } = useLiveEventData();

  const discountsAppliedText = formatMessage({ id: 'DISCOUNTS APPLIED', defaultMessage: 'DISCOUNTS APPLIED' });

  const hasBogo = ticketInfo?.availability?.hasBogoTickets;
  const hasEarlyBird = ticketInfo?.availability?.hasEarlyBirdTickets;
  const hasDiscounts = ticketInfo?.discounts && ticketInfo?.discounts?.length > 0;

  const discountCount = [hasBogo, hasEarlyBird, hasDiscounts].filter(Boolean).length;

  if (discountCount > 1 || hasDiscounts) {
    discountText = discountsAppliedText;
  } else if (hasBogo) {
    discountText = formatMessage({ id: '2 FOR 1 DEAL', defaultMessage: '2 FOR 1 DEAL' });
  } else if (hasEarlyBird) {
    discountText = formatMessage({
      id: 'EARLY BIRD DISCOUNT APPLIED',
      defaultMessage: 'EARLY BIRD DISCOUNT APPLIED',
    });
  }

  if (!discountText) {
    return null;
  }

  return (
    <span className={styles.discountSignal}>
      <DiscountSignalIcon />
      {discountText}
    </span>
  );
};
